/**
 * @version
 */
export var AUI_VERSION = '1.6.0-beta.4';
//# sourceMappingURL=version.js.map